import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ThumbDown24() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.0928 3.00005H5.91193C5.5174 3.00044 5.13217 3.1053 4.80657 3.30094C4.48097 3.49658 4.23014 3.7739 4.08683 4.09668L1.03943 10.443C0.946433 10.6529 0.899273 10.8762 0.900411 11.1014V12.9108C0.900411 13.8995 1.80777 15.0012 2.91932 15.0012H7.99729C8.64848 15.0012 9.12595 15.6137 8.96707 16.2452L8.31905 18.8209L8.28674 19.102C8.28686 19.4578 8.44592 19.7994 8.72975 20.0533C9.34566 20.5941 10.2679 20.5917 10.881 20.0477L16.5337 15.0311C16.9122 14.692 17.1232 14.2355 17.1209 13.7607V4.76226C17.1202 4.52945 17.067 4.29906 16.9646 4.08434C16.8621 3.86961 16.7124 3.67478 16.5239 3.51103C16.3355 3.34728 16.112 3.21784 15.8664 3.13015C15.6208 3.04246 15.3579 2.99825 15.0928 3.00005Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.1003 12.4988C23.1003 13.0511 22.6526 13.4988 22.1003 13.4988H20.6826C20.1303 13.4988 19.6826 13.0511 19.6826 12.4988V4C19.6826 3.44772 20.1303 3 20.6826 3H22.1003C22.6526 3 23.1003 3.44772 23.1003 4V12.4988Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
}